// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navigation-drawer--temporary .list__tile__action[data-v-0eaa568c] {\n  padding-left: 10px;\n}\n.v-list__tile__action[data-v-0eaa568c] {\n  padding-left: 10px;\n}\n.v-navigation-drawer--mini-variant .v-list__tile__action[data-v-0eaa568c] {\n  padding-left: unset;\n}\n", ""]);
// Exports
module.exports = exports;
